import MaterialTable from "material-table";
import React from "react";
import tableIcons, { options } from "components/universal/table_attributes";
import MailSend from "assets/mail-send.svg";

const FavouritesTable = (props) => {
  const {
    loading,
    page,
    pageSize,
    totalCount,
    setPage,
    setPageSize,
    handleOpenAction,
    tableData,
  } = props;

  const tableOptions = {
    ...options,
    page,
    total: totalCount,
    pageSize,
    search: false,
    toolbar: false,
  };

  const columns = [
    {
      title: "Report #",
      field: "id",
      headerStyle: {
        textAlign: "left",
        width: "7%",
        paddingLeft: "15px",
      },
      cellStyle: {
        width: "7%",
        paddingLeft: "15px",
      },
    },

    {
      title: "Category",
      field: "category",
      headerStyle: {
        width: "7%",
        textAlign: "left",
      },
      cellStyle: {
        width: "7%",
        textAlign: "left",
      },
    },

    {
      title: "Name",
      field: "name",
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
      },
    },

    {
      title: "Action",
      field: "action",
      headerStyle: {
        width: "7%",
      },
      cellStyle: {
        width: "7%",
      },
      render: (rowData) => (
        <div
          onClick={() => handleOpenAction(rowData)}
          style={{
            backgroundColor: "transparent",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          <img src={MailSend} alt="Icon" style={{ height: "24px" }} />
        </div>
      ),
    },
  ];
  const tableStyle = { boxShadow: "0px 1px 3px #00000033" };
  const localization = {
    body: {
      emptyDataSourceMessage: "No Favourites found",
    },
  };
  const handlePageChange = (changedPage) => setPage(changedPage);
  const handlePageSizeChange = (changedPageSize) =>
    setPageSize(changedPageSize);

  return (
    <MaterialTable
      style={tableStyle}
      icons={tableIcons}
      title={""}
      columns={columns}
      data={tableData}
      isLoading={loading}
      options={tableOptions}
      localization={localization}
      onChangePage={handlePageChange}
      onChangeRowsPerPage={handlePageSizeChange}
      totalCount={totalCount}
      page={page}
    />
  );
};

export default FavouritesTable;
